import React, { useEffect, useRef, useState } from 'react';
import { getAttributes } from '../utils';
import { css, cx } from 'emotion';
import { useContent, Content } from '../../brite-viewer-v2/ContentProvider';
import { Box } from '../../../shared-components/Box';
import { Link } from 'phosphor-react';
import { Text } from '../../../shared-components';
import { container } from '../../../shared-components/shared-styles';
import { QR } from '../../../shared-components/QR';
import { colors } from '../../../shared-components/styles';

function executeDevCommands(devBlockContent) {
  // if devBlockContent does not start with an opening bracket then we'll assume it's not a command we need to care about
  if (!devBlockContent || !devBlockContent.trim().startsWith('[')) {
    return;
  }

  let commands;

  try {
    commands = JSON.parse(devBlockContent);
  } catch (err) {
    console.warn('Failed to parse dev commands JSON:', err);
    return;
  }

  if (!Array.isArray(commands)) {
    console.warn('Dev commands should be an array');
    return;
  }

  for (const cmd of commands) {
    if (!cmd.command) continue;

    const args = cmd.args || {};

    console.debug('Executing dev command:', cmd.command, cmd.args);

    switch (cmd.command) {
      case 'redirect':
        if (typeof args.to === 'string') {
          const delay = typeof args.delay === 'number' ? args.delay : 0;
          setTimeout(() => {
            window.location.href = args.to;
          }, delay);
        } else {
          console.warn('Invalid redirect command:', cmd);
        }
        break;

      default:
        console.warn('Unknown dev command:', cmd.command);
    }
  }
}

export const DevBlock = ({ item, totalColumns }) => {
  useEffect(() => {
    if (item?.data?.content) {
      executeDevCommands(item.data.content);
    }
  }, [item, totalColumns]);

  return null;
};
